import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const Svg = styled.svg`
  @media only screen and (max-width: 47.95em) {
    width: 100%;
    height: auto;
  }
`;

const TestSeriesThumbnail = ({ color, className, width, height }) => (
  <Svg
    width={width}
    height={height}
    viewBox="0 0 320 180"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0)">
      <rect width="320" height="180" rx="8" fill={color || 'green'} />
      <path
        d="M16.0739 17.1241C16.6104 20.5496 19.5597 23.1693 23.1176 23.1693C26.6395 23.1693 29.5651 20.6023 30.1443 17.2278C30.2185 16.911 30.2492 16.658 30.2398 16.4412C30.2398 16.1928 30.0628 16 29.8174 16H29.4194H16.8828H16.424C16.1788 16 16.0019 16.1925 16.0016 16.4406C16.0011 16.4406 16.0005 16.4406 16 16.4406C16.0003 16.4461 16.0007 16.4517 16.001 16.4572C15.9946 16.646 16.0182 16.8624 16.0739 17.1241L16.0739 17.1241Z"
        fill="white"
      />
      <path
        d="M26.6178 27.559C26.3496 25.8463 24.8749 24.5365 23.0959 24.5365C21.335 24.5365 19.8722 25.8199 19.5826 27.5072C19.5455 27.6656 19.5301 27.7921 19.5348 27.9005C19.5348 28.0247 19.6233 28.1211 19.746 28.1211H19.945H26.2134H26.4428C26.5654 28.1211 26.6538 28.0248 26.654 27.9008C26.6542 27.9008 26.6545 27.9008 26.6548 27.9008C26.6546 27.898 26.6544 27.8953 26.6543 27.8925C26.6575 27.7981 26.6457 27.6899 26.6178 27.559Z"
        fill="white"
      />
      <path
        d="M45.3714 22.9514C45.3714 23.755 45.7464 24.438 46.6839 24.438C47.6214 24.438 47.9964 23.755 47.9964 22.9514L47.9964 19.1211L49.55 19.1211L49.55 23.2327C49.55 24.6791 48.2375 25.8309 46.6839 25.8309C45.1304 25.8309 43.8179 24.6791 43.8179 23.2327L43.8179 19.1211L45.3714 19.1211L45.3714 22.9514Z"
        fill="white"
      />
      <path
        d="M50.4966 23.8616C50.5769 24.5982 51.3001 25.8303 53.1885 25.8303C54.8492 25.8303 55.6528 24.7321 55.6528 23.741C55.6528 22.7768 55.0099 22.0268 53.7778 21.7589L52.7867 21.558C52.385 21.4777 52.1305 21.2232 52.1305 20.875C52.1305 20.4732 52.5189 20.125 53.068 20.125C53.9385 20.125 54.2198 20.7277 54.2733 21.1027L55.5858 20.7277C55.4787 20.0848 54.8894 18.9063 53.068 18.9063C51.7153 18.9063 50.6707 19.8705 50.6707 21.0089C50.6707 21.9062 51.2734 22.6562 52.4251 22.9107L53.3894 23.125C53.9117 23.2321 54.1528 23.5 54.1528 23.8482C54.1528 24.25 53.818 24.5982 53.1751 24.5982C52.3448 24.5982 51.9028 24.0759 51.8492 23.4866L50.4966 23.8616Z"
        fill="white"
      />
      <path
        d="M34.3844 28.1205L34.3844 24.8392C34.7192 25.3348 35.429 25.7366 36.3665 25.7366C38.2415 25.7366 39.4335 24.2634 39.4335 22.308C39.4335 20.3795 38.3487 18.9063 36.4201 18.9063C35.4156 18.9063 34.6657 19.375 34.3442 19.9375L34.3442 19.0536L32.8442 19.0536L32.8442 28.1205L34.3844 28.1205ZM37.8799 22.308C37.8799 23.5535 37.1567 24.3571 36.1255 24.3571C35.1076 24.3571 34.371 23.5535 34.371 22.308C34.371 21.0893 35.1076 20.2857 36.1255 20.2857C37.1701 20.2857 37.8799 21.0893 37.8799 22.308Z"
        fill="white"
      />
      <path
        d="M40.8188 25.7767L40.8188 16L42.3599 16L42.3599 25.7767L40.8188 25.7767Z"
        fill="white"
      />
      <g style={{ mixBlendMode: 'multiply' }}>
        <circle cx="160" cy="113" r="97" fill={color || 'red'} />
      </g>
      <mask
        id="mask0"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="16"
        width="194"
        height="194"
      >
        <circle cx="160" cy="113" r="97" fill={color} />
      </mask>
      <g mask="url(#mask0)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M208.743 105.446C209.13 105.837 209.44 106.297 209.657 106.8C209.885 107.316 210.002 107.873 210 108.436V181.769C209.985 182.887 209.529 183.954 208.728 184.745C207.928 185.535 206.846 185.985 205.714 186H114.286C113.154 185.985 112.072 185.535 111.272 184.745C110.471 183.954 110.015 182.887 110 181.769V80.2308C110.015 79.1133 110.471 78.0456 111.272 77.2553C112.072 76.4651 113.154 76.0146 114.286 76H177.143C177.713 75.9983 178.277 76.1135 178.8 76.3385C179.31 76.5526 179.775 76.8586 180.171 77.241L208.743 105.446ZM124.846 103.982C124.846 97.751 129.897 92.6998 136.128 92.6998H136.421C142.652 92.6998 147.703 97.751 147.703 103.982C147.703 110.213 142.652 115.264 136.421 115.264H136.128C129.897 115.264 124.846 110.213 124.846 103.982ZM175.061 90.2972L197.918 112.861H175.061V90.2972ZM180.347 135.216H128.919C127.782 135.216 126.692 135.662 125.888 136.455C125.084 137.249 124.633 138.325 124.633 139.447C124.633 140.569 125.084 141.645 125.888 142.439C126.692 143.232 127.782 143.678 128.919 143.678H180.347C181.484 143.678 182.574 143.232 183.378 142.439C184.181 141.645 184.633 140.569 184.633 139.447C184.633 138.325 184.181 137.249 183.378 136.455C182.574 135.662 181.484 135.216 180.347 135.216ZM128.919 157.78H163.204C164.341 157.78 165.431 158.226 166.235 159.019C167.038 159.813 167.49 160.889 167.49 162.011C167.49 163.133 167.038 164.209 166.235 165.003C165.431 165.796 164.341 166.242 163.204 166.242H128.919C127.782 166.242 126.692 165.796 125.888 165.003C125.084 164.209 124.633 163.133 124.633 162.011C124.633 160.889 125.084 159.813 125.888 159.019C126.692 158.226 127.782 157.78 128.919 157.78Z"
          fill="white"
        />
      </g>
      <mask
        id="mask1"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="200"
        y="16"
        width="80"
        height="80"
      >
        <circle cx="240" cy="56" r="40" fill="white" />
      </mask>
      <g mask="url(#mask1)">
        <line
          x1="178.576"
          y1="84.6763"
          x2="229.817"
          y2="-12.2693"
          stroke="white"
          strokeWidth="0.75"
        />
        <line
          x1="180.569"
          y1="85.7291"
          x2="231.81"
          y2="-11.2166"
          stroke="white"
          strokeWidth="0.75"
        />
        <line
          x1="182.563"
          y1="86.7837"
          x2="233.804"
          y2="-10.1619"
          stroke="white"
          strokeWidth="0.75"
        />
        <line
          x1="184.556"
          y1="87.8365"
          x2="235.797"
          y2="-9.10913"
          stroke="white"
          strokeWidth="0.75"
        />
        <line
          x1="186.548"
          y1="88.8892"
          x2="237.789"
          y2="-8.0564"
          stroke="white"
          strokeWidth="0.75"
        />
        <line
          x1="188.542"
          y1="89.9439"
          x2="239.783"
          y2="-7.00171"
          stroke="white"
          strokeWidth="0.75"
        />
        <line
          x1="190.535"
          y1="90.9966"
          x2="241.776"
          y2="-5.94897"
          stroke="white"
          strokeWidth="0.75"
        />
        <line
          x1="192.528"
          y1="92.0494"
          x2="243.769"
          y2="-4.89624"
          stroke="white"
          strokeWidth="0.75"
        />
        <line
          x1="194.521"
          y1="93.1041"
          x2="245.762"
          y2="-3.84155"
          stroke="white"
          strokeWidth="0.75"
        />
        <line
          x1="196.514"
          y1="94.1568"
          x2="247.755"
          y2="-2.78882"
          stroke="white"
          strokeWidth="0.75"
        />
        <line
          x1="198.507"
          y1="95.2095"
          x2="249.748"
          y2="-1.73608"
          stroke="white"
          strokeWidth="0.75"
        />
        <line
          x1="200.5"
          y1="96.2642"
          x2="251.741"
          y2="-0.681396"
          stroke="white"
          strokeWidth="0.75"
        />
        <line
          x1="202.493"
          y1="97.317"
          x2="253.734"
          y2="0.371339"
          stroke="white"
          strokeWidth="0.75"
        />
        <line
          x1="204.486"
          y1="98.3697"
          x2="255.727"
          y2="1.42407"
          stroke="white"
          strokeWidth="0.75"
        />
        <line
          x1="206.479"
          y1="99.4244"
          x2="257.72"
          y2="2.47876"
          stroke="white"
          strokeWidth="0.75"
        />
        <line
          x1="208.472"
          y1="100.477"
          x2="259.713"
          y2="3.5315"
          stroke="white"
          strokeWidth="0.75"
        />
        <line
          x1="210.465"
          y1="101.532"
          x2="261.706"
          y2="4.58618"
          stroke="white"
          strokeWidth="0.75"
        />
        <line
          x1="212.458"
          y1="102.585"
          x2="263.699"
          y2="5.63892"
          stroke="white"
          strokeWidth="0.75"
        />
        <line
          x1="214.451"
          y1="103.637"
          x2="265.692"
          y2="6.69165"
          stroke="white"
          strokeWidth="0.75"
        />
        <line
          x1="216.444"
          y1="104.692"
          x2="267.685"
          y2="7.74634"
          stroke="white"
          strokeWidth="0.75"
        />
        <line
          x1="218.438"
          y1="105.745"
          x2="269.679"
          y2="8.79907"
          stroke="white"
          strokeWidth="0.75"
        />
        <line
          x1="220.431"
          y1="106.797"
          x2="271.672"
          y2="9.85181"
          stroke="white"
          strokeWidth="0.75"
        />
        <line
          x1="222.423"
          y1="107.85"
          x2="273.664"
          y2="10.9045"
          stroke="white"
          strokeWidth="0.75"
        />
        <line
          x1="224.417"
          y1="108.905"
          x2="275.658"
          y2="11.9592"
          stroke="white"
          strokeWidth="0.75"
        />
        <line
          x1="226.41"
          y1="109.958"
          x2="277.651"
          y2="13.012"
          stroke="white"
          strokeWidth="0.75"
        />
        <line
          x1="228.403"
          y1="111.012"
          x2="279.644"
          y2="14.0667"
          stroke="white"
          strokeWidth="0.75"
        />
        <line
          x1="230.396"
          y1="112.065"
          x2="281.637"
          y2="15.1194"
          stroke="white"
          strokeWidth="0.75"
        />
        <line
          x1="232.389"
          y1="113.118"
          x2="283.63"
          y2="16.1721"
          stroke="white"
          strokeWidth="0.75"
        />
        <line
          x1="234.382"
          y1="114.172"
          x2="285.623"
          y2="17.2268"
          stroke="white"
          strokeWidth="0.75"
        />
        <line
          x1="236.375"
          y1="115.225"
          x2="287.616"
          y2="18.2795"
          stroke="white"
          strokeWidth="0.75"
        />
        <line
          x1="238.368"
          y1="116.278"
          x2="289.609"
          y2="19.3323"
          stroke="white"
          strokeWidth="0.75"
        />
        <line
          x1="240.359"
          y1="117.333"
          x2="291.6"
          y2="20.387"
          stroke="white"
          strokeWidth="0.75"
        />
        <line
          x1="242.353"
          y1="118.385"
          x2="293.594"
          y2="21.4397"
          stroke="white"
          strokeWidth="0.75"
        />
        <line
          x1="244.345"
          y1="119.438"
          x2="295.586"
          y2="22.4924"
          stroke="white"
          strokeWidth="0.75"
        />
        <line
          x1="246.338"
          y1="120.493"
          x2="297.579"
          y2="23.5471"
          stroke="white"
          strokeWidth="0.75"
        />
        <line
          x1="248.332"
          y1="121.545"
          x2="299.573"
          y2="24.5999"
          stroke="white"
          strokeWidth="0.75"
        />
        <line
          x1="250.325"
          y1="122.598"
          x2="301.566"
          y2="25.6526"
          stroke="white"
          strokeWidth="0.75"
        />
        <line
          x1="252.317"
          y1="123.653"
          x2="303.558"
          y2="26.7073"
          stroke="white"
          strokeWidth="0.75"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="320" height="180" fill="white" />
      </clipPath>
    </defs>
  </Svg>
);

export default TestSeriesThumbnail;

TestSeriesThumbnail.propTypes = {
  color: PropTypes.string.isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string
};

TestSeriesThumbnail.defaultProps = {
  width: '320px',
  height: '180px',
  className: ''
};
